import React, { useEffect, useState } from "react";
import api from "../../../api/axios";
import { Link } from "react-router-dom";
import LoadingOverlay from "../../../components/LoadingOverlay";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const COLORS = ["#2563eb", "#16a34a", "#f59e0b", "#dc2626"];

function ActivesDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboard();
  }, []);

  const fetchDashboard = async () => {
    try {
      setLoading(true);
      const res = await api.get("/actives/dashboard/summary");
      setData(res.data);
    } catch (error) {
      console.error("Error cargando dashboard de activos", error);
    } finally {
      setLoading(false);
    }
  };

  if (!data) return null;

  // ===============================
  // ADAPTAMOS LOS DATOS
  // ===============================
  const stateData = data.byState.map((item) => ({
    name: item.state,
    value: Number(item.total),
  }));

 const categoryData = data.byCategory.map((item) => ({
  name: item.name,
  value: Number(item.total),
}));

const locationData = data.byLocation.map((item) => ({
  name: item.name,
  value: Number(item.total),
}));

  const inRepair =
    stateData.find((s) => s.name === "Reparación")?.value || 0;

  return (
    <div className="bg-white p-6 rounded-xl shadow-md relative">
      <LoadingOverlay loading={loading} />
    
      <h2 className="text-3xl font-semibold text-gray-800 mb-6">
        Dashboard de Activos
      </h2>

      {/* ===============================
          TARJETAS
      =============================== */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
        <DashboardCard title="Total Activos" value={data.totalActives} />
        <DashboardCard title="Categorías" value={categoryData.length} />
        <DashboardCard title="Ubicaciones" value={locationData.length} />
        <DashboardCard
          title="En reparación"
          value={inRepair}
          color="text-red-600"
        />
      </div>

      {/* ===============================
          TABLAS
      =============================== */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <SummaryTable title="Activos por Categoría" data={categoryData} />
        <SummaryTable title="Activos por Ubicación" data={locationData} />
      </div>
    </div>
  );
}

export default ActivesDashboard;

// ===============================
// COMPONENTES
// ===============================

const DashboardCard = ({ title, value, color = "text-blue-600" }) => (
  <div className="bg-gray-50 p-6 rounded-xl shadow text-center">
    <h4 className="text-gray-500 mb-2">{title}</h4>
    <p className={`text-3xl font-bold ${color}`}>{value}</p>
  </div>
);

const SummaryTable = ({ title, data }) => (
  <div className="bg-gray-50 p-6 rounded-xl shadow">
    <h3 className="text-xl font-semibold mb-4">{title}</h3>
    <table className="w-full text-sm">
      <thead>
        <tr className="text-gray-600 border-b">
          <th className="text-left py-2">Nombre</th>
          <th className="text-right py-2">Cantidad</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, i) => (
          <tr key={i} className="border-b last:border-none">
            <td className="py-2">{item.name}</td>
            <td className="py-2 text-right font-semibold">{item.value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
